import React, {  } from "react";

const PhysicianDraftScript = ({ component: RouteComponent, test, passenger, physician, ...rest }) => {

   

   return (

      <div>
         <meta charSet="utf-8" />
         <title>Script</title>
         <style dangerouslySetInnerHTML={{ __html: "\n\n    @font-face {\n      \n      font-style: normal;\n      font-weight: 400;\n      \n    }\n\n    @font-face {\n      \n      font-style: normal;\n      font-weight: 600;\n     \n    }\n\n    html, body {\n        margin: 0;\n        padding: 0;\n    }\n\n    .invoice-box {\n        max-width: 800px;\n        margin: auto;\n        padding: 30px;\n        font-size: 12px;\n        line-height: 18px;\n    \n        color: #555;\n    }\n\n    .invoice-box table {\n        width: 100%;\n        line-height: inherit;\n        text-align: left;\n    }\n\n    .invoice-box table td {\n        padding: 5px;\n        vertical-align: top;\n    }\n\n    .invoice-box table tr td:nth-child(2) {\n        text-align: right;\n    }\n\n    .invoice-box table tr.top table td {\n        padding-bottom: 20px;\n    }\n\n    .invoice-box table tr.top table td.title {\n        font-size: 14px;\n        line-height: 45px;\n        color: #333;\n    }\n\n    .invoice-box table tr.information table td {\n        padding-bottom: 40px;\n    }\n\n    .invoice-box table tr.heading td {\n        background: #eee;\n        border-bottom: 1px solid #ddd;\n        font-weight: 600;\n    }\n\n    .invoice-box table tr.details td {\n        padding-bottom: 20px;\n    }\n\n    .invoice-box table tr.item td{\n        border-bottom: 1px solid #eee;\n    }\n\n    .invoice-box table tr.item.last td {\n        border-bottom: none;\n    }\n\n    .invoice-box table tr.total td:nth-child(2) {\n        border-top: 2px solid #eee;\n        font-weight: 600;\n    }\n\n    @media only screen and (max-width: 600px) {\n        .invoice-box table tr.top table td {\n            width: 100%;\n            display: block;\n            text-align: center;\n        }\n\n        .invoice-box table tr.information table td {\n            width: 100%;\n            display: block;\n            text-align: center;\n        }\n    }\n\n    .paid {\n        color: green;\n        font-weight: 600;\n        font-size: 14px;\n        border: 1px solid green;\n        border-radius: 6px;\n        display: inline-block;\n        margin-top: 12px;\n        padding: 6px 12px;\n    }\n\n    /** RTL **/\n    .rtl {\n        direction: rtl;\n       \n    }\n\n    .rtl table {\n        text-align: right;\n    }\n\n    .rtl table tr td:nth-child(2) {\n        text-align: left;\n    }\n    " }} />
         <div className="invoice-box">
            <table cellPadding={0} cellSpacing={0}>
               <tbody><tr className="top">
                  <td colSpan={2}>
                     <table>
                        <tbody><tr>
                           <td className="title">
                              
                           </td>
                           <td>
                              Reference ID: {test.id}<br />
                    Created date: {new Date(test.createdOn).toLocaleString() }<br />
                           </td>
                        </tr>
                        </tbody></table>
                  </td>
               </tr>
                  <tr><td><br /></td></tr>
                  <tr className="heading">
                     <td>Physician Information</td>
                     <td />
                  </tr>
                  <tr className="top">
                     <td className="title">
                        Physician's Name: {physician.name}<br />
            Physician's Address: {physician.address}<br />
                        Physician's NPI: {physician.physicianNPI}<br />
            Physician's Phone: {physician.phone}<br />
                     </td>
                  </tr>
                  <tr><td><br /></td></tr>
                  <tr className="heading">
                     <td>Patient Information</td>
                     <td />
                  </tr>
                  <tr className="information">
                     <td>
                        Requestors Name: {passenger.name}<br />
            Requestors Home Address {passenger.address.address}<br />
                     </td>
                  </tr>
                  <tr><td><br /></td></tr>
                  <tr className="heading">
                     <td>Test Requested</td>
                     <td />
                  </tr>
                  <tr className="item last">
                     <td>SARS-COV-2 RT PCR - Nasal-pharyngeal</td>
                  </tr>
                  <tr className="item last">
                     <td>Code: {passenger.testPurpose}</td>
                  </tr>
                  <tr><td><br /></td></tr>
                  <tr className="heading">
                     <td />
                     <td>
                        Signature
          </td>
                  </tr>
                  <tr className="item last">
                     <td />
                     <td>
                        <img src={physician.signature} style={{ width: '100%', maxWidth: 120 }} />
                     </td>
                  </tr>
                  <tr className="total">
                     <td />
                     <td>{new Date().toLocaleString()}</td>
                  </tr>
               </tbody></table>
         </div>
      </div>);
}

export default PhysicianDraftScript;